export enum CancellationServiceFileTypeSteps {
  CUSTOMER_DETAILS = "Customer Details",
  PURCHASE_DETAILS = "Purchase Details",
  CANCELLATION_REASON = "Cancellation Reason",
  REVIEW_DETAILES = "Review Details",
}

export const CancellationServiceSteps = [
  {
    step_num: 1,
    title: CancellationServiceFileTypeSteps.CUSTOMER_DETAILS,
  },
  {
    step_num: 2,
    title: CancellationServiceFileTypeSteps.PURCHASE_DETAILS,
  },
  {
    step_num: 3,
    title: CancellationServiceFileTypeSteps.CANCELLATION_REASON,
  },
  {
    step_num: 4,
    title: CancellationServiceFileTypeSteps.REVIEW_DETAILES,
  },
];
